module.exports = __webpack_public_path__ + "img/bilge-pump-on-icon.43fba666.svg";